import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { SettingsService } from '../services/settings.service';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RecuperarPasswordService {

  constructor(
    private http: HttpClient,
    private settings: SettingsService
  ) { }

   enviarCodigoRecuperacion(filtro: any): Observable<any> {

    const payload = {
      ...filtro,
      aplicacionId: this.settings.APP_ID,
      aplicacionVersion: this.settings.APP_VERSION
    };

      return this.http.post(`${this.settings.URL_BASE}seguridad/usuario/clave/olvidada`, payload);
    }
}
